import { render, staticRenderFns } from "./MedalPopup.vue?vue&type=template&id=7a2672df&"
import script from "./MedalPopup.vue?vue&type=script&lang=js&"
export * from "./MedalPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports